import { lazy, Suspense } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useUserStore } from '../../stores';
import LoadingWindow from '../common/ui/LoadingWindow';

const LightMarketingThemeProvider = lazy(() => import('../../themes/LightMarketingThemeProvider'));

// This component wraps marketing routes and applies the marketing theme
export const MarketingRoute = () => {
  const { user, loading: authLoading } = useUserStore();

  // Show loading while determining auth state
  if (authLoading) {
    return <LoadingWindow fullScreen={true} overlay={true} message="Loading..." />;
  }

  // If user is authenticated, redirect to dashboard
  if (user) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <Suspense fallback={<LoadingWindow fullScreen={true} overlay={true} message="Loading..." />}>
      <LightMarketingThemeProvider>
        <Outlet />
      </LightMarketingThemeProvider>
    </Suspense>
  );
};
